<template>
    <!--            &#45;&#45; Tailwind UI -> Data Display -> Description Lists -> Left-aligned in card &#45;&#45;-->
    <div class="w-full bg-white shadow overflow-hidden sm:rounded-lg">
        <div class="px-4 py-5 border-b border-gray-200 sm:px-6 mb-2 sm:mb-10">
            <p class="mt-1 max-w-2xl text-lg leading-5 text-gray-800">
                Add a comment to the alarm; this won't change the alarm status.
            </p>
            <p class="mt-1 max-w-2xl text-lg leading-5 text-gray-800">

            </p>
        </div>
        <div class="px-4 py-5 sm:p-0">
            <dl>
                <div class="mt-2 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                    <dt class="text-sm leading-5 font-medium text-gray-500">
                        Comments
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                        <textarea v-model="comments" class="w-full border-2 p-4" rows="4"
                                  placeholder="Enter any comments here"></textarea>
                    </dd>
                </div>
            </dl>
        </div>
        <div class="px-4 py-5 sm:border-t mt-2 p-1">
            <dl class="mb-0">
                    <span class="mt-3 inline-flex rounded-md shadow-sm sm:mt-0 sm:ml-3 sm:w-auto">
                        <button type="button"
                                @click="sendFormData"
                                :disabled="!anythingEntered"
                                :class="{'bg-gray-400': !anythingEntered, 'bg-blue-600 hover:bg-blue-500': anythingEntered}"
                                class="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent font-medium rounded-md text-white focus:outline-none focus:border-blue-700 focus:ring-indigo-200 active:bg-blue-700 sm:w-auto sm:text-sm sm:leading-5">
                          Place comment on alarm
                        </button>
                      </span>
            </dl>
        </div>
    </div>

</template>

<script>
    import axios from 'axios';

    export default {
        name: "alarmAddressComment",
        props: {
            sendEventOnly: Boolean,
        },
        data() {
            return {
                comments: '',
            }
        },
        computed: {
            anythingEntered: function () {
                return this.comments.length > 0;
            }
        },
        methods: {
            sendFormData() {
                // Data to send to form
                let data = {
                    'addressed': 'comment',
                    'comments': this.comments,
                }
                if (this.sendEventOnly) {
                    // If we're only sending the event, emit the event and return
                    this.$emit('adding-comment', data)
                    return
                }

                // Send the data to the server and emit the response.
                axios.patch(window.location.pathname,
                    data
                ).then(response => {
                    this.$emit('add-comment', response.data)
                    this.comments = ''
                });
            },
        }
    }
</script>

<style scoped>

</style>